import { render, staticRenderFns } from "./downloading.vue?vue&type=template&id=fde25c4a&scoped=true"
import script from "./downloading.vue?vue&type=script&lang=js"
export * from "./downloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde25c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde25c4a')) {
      api.createRecord('fde25c4a', component.options)
    } else {
      api.reload('fde25c4a', component.options)
    }
    module.hot.accept("./downloading.vue?vue&type=template&id=fde25c4a&scoped=true", function () {
      api.rerender('fde25c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/downloading.vue"
export default component.exports